<template>
	<header class="navbar">
		<div class="container">
			<!-- on tablets and pcs -->
			<div class="hidden-xs">
				<a href="#/" class="navbar-brand">
					<img src="../../../assets/img/brasao.png" class="pull-left" alt="logo">
					<span class="title">FALE COM O PREFEITO</span>
					<span class="title" style="color:tomato;">{{ env }}</span>
				</a>

				<span class="navbar-btn pull-right">
					<router-link to="/" class="btn btn-warning" exact>
						<i class="fa fa-info-circle"></i>
						INSTRUÇÕES
					</router-link>

					<router-link to="/agendas" class="btn btn-warning" exact>
						<i class="fa fa-calendar"></i>
						AGENDAS
					</router-link>

					<v-logged-user></v-logged-user>
				</span>
			</div>

			<!-- on smartphones -->
			<div class="visible-xs text-center">
				<a href="#/">
					<img src="../../../assets/img/brasao.png" alt="logo">
					<div class="title" style="font-size:24px;">FALE COM O PREFEITO</div>
					<span class="title" style="font-size:24px;color:tomato;">{{ env }}</span>
				</a>
				<div class="btn-group btn-group-justified" style="margin-bottom:10px;">
					<div class="btn-group">
						<router-link to="/" class="btn btn-warning" exact>
							<i class="fa fa-info-circle"></i>
							INSTRUÇÕES
						</router-link>
					</div>
					<div class="btn-group">
						<router-link to="/agendas" class="btn btn-warning" exact>
							<i class="fa fa-calendar"></i>
							AGENDAS
						</router-link>
					</div>
				</div>
				<v-logged-user class="btn-block"></v-logged-user>
			</div>
		</div>
	</header>
</template>

<script>
	import VLoggedUser from 'views/permisys/loggedUser';

	export default {
		components: { VLoggedUser },

		data() {
			return {
				env: Config.ENV
			};
		}
	};
</script>

<style scoped>
	header {
		margin: 0;
		border: 0;
		padding: 10px 0;
		background: #286b86;
		border-radius: 0;
		box-shadow: 0 3px 3px rgba(0, 0, 0, .2);
	}

	header a:active,
	header a:focus,
	header a:hover {
		text-decoration: none;
	}

	header .title {
		font-weight: 700;
		color: goldenrod;
		text-shadow: 0px 2px 1px rgba(0, 0, 0, .2);
		font-size: 28px;
	}

	header .title:hover {
		text-decoration: none;
	}

	header .hidden-xs a:not(.btn) {
		margin-left: -15px;
		line-height: 18px;
	}

	header .hidden-xs img {
		margin: -14px 10px 0 0;
	}
</style>


// WEBPACK FOOTER //
// header.vue?635e5eea